import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css',
})
export class NotificationComponent {
  // Lista de notificaciones
  @Input() notifications: string[] = [];

  // Estado que controla la visibilidad de la lista de notificaciones
  showNotifications: boolean = false;

  // Evento que se emite cuando el usuario hace clic en la campana
  @Output() onBellClick = new EventEmitter<void>();

  // Agregar un método para manejar clics en el documento
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const bellContainer = document.querySelector('.bell-container');
    const notificationList = document.querySelector('.notification-list');

    // Si el clic no fue dentro del contenedor de la campana ni en la lista de notificaciones
    if (
      bellContainer &&
      notificationList &&
      !bellContainer.contains(target) &&
      !notificationList.contains(target)
    ) {
      this.showNotifications = false;
    }
  }

  // Función para mostrar/ocultar las notificaciones
  toggleNotifications(event: MouseEvent) {
    event.stopPropagation(); // Evitar que el clic se propague al documento
    this.showNotifications = !this.showNotifications;
    this.onBellClick.emit();
  }

  // Función para limpiar las notificaciones (opcional)
  clearNotifications() {
    this.notifications = [];
  }
}
